<template>
  <div class="undo-container">
    <template v-if="!showOnlyCount">
      <p>Undo status change for {{ data.funds.length }} clients for the fund:</p>
      <p>{{ shareclassName }}</p>
      <div class="submit-actions">
        <button class="mds-button" type="button" @click="closeModal">
          Cancel
        </button>
        <mds-button variation="primary" class="submit-button" @click="doUndo"> Undo Status Change </mds-button>
      </div>
    </template>
    <template v-else>
      <p>This action will undo status change for {{ `(${data.funds.length})` }} fund Ids.</p>
      <div class="submit-actions">
        <button class="mds-button" type="button" @click="closeModal">
          Cancel
        </button>
        <mds-button variation="primary" class="submit-button" @click="doUndo"> Continue </mds-button>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { undoChangesForPendingFunds } from '@/services/PendingFunds';

export default {
  name: 'undo-changes',
  components: {},
  data() {
    return {};
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      closeModal: 'closeModal',
      closeModalAfterSuccess: 'closeModalAfterSuccess',
    }),
    doUndo() {
      const payload = {
        fiduciaryFundIds: this.data.funds,
      };
      undoChangesForPendingFunds({
        fiduciaryNumber: this.fiduciaryNumber,
        payload,
      }).then((result) => {
        this.closeModalAfterSuccess();
        if (result.status.success) {
          // force the grid to reload
          this.$store.dispatch('setReloadNeed', true);
          this.$store.dispatch('openNotification', {
            message: 'Status change for fund has been undone',
          });
        }
      }).catch((error) => {
        const httpStatus = (error?.response?.status) ? (error?.response.status) : error?.status;
        if (httpStatus === 401) {
          this.$router.push('/Login');
        }
      });
    },
  },
  computed: {
    ...mapState({
      fiduciaryNumber: (state) => state.user.fiduciary.id,
    }),
    shareclassName() {
      return this.data.shareclassName;
    },
    showOnlyCount() {
      return this.data.shareclassName === '';
    },
  },
};
</script>
<style lang="scss">
.undo-container {
  @include mds-body-text-m();
  p {
    padding-bottom: $mds-space-1-and-a-half-x;
  }
  .submit-actions {
    button:not(:first-child) {
      margin-left: $mds-space-1-and-a-half-x;
    }
  }
}
</style>
